import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "api-reference"
    }}>{`API Reference`}</h1>
    <h2 {...{
      "id": "createaction"
    }}>{`createAction`}</h2>
    <p>{`Returns a Flux Standard ActionCreator`}</p>
    <h3 {...{
      "id": "params"
    }}>{`Params:`}</h3>
    <ul>
      <li parentName="ul">{`type: string`}</li>
      <li parentName="ul">{`namespace (optional): string`}</li>
    </ul>
    <h3 {...{
      "id": "usage"
    }}>{`Usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createAction } from "re-reduced";

const action1 = createAction("DO_SOMETHING");

console.log(action1.type); // => "DO_SOMETHING"

const action2 = createAction("DO_SOMETHING", "NAMESPACE");

console.log(action2.type); // => "NAMESPACE/DO_SOMETHING"
`}</code></pre>
    <h2 {...{
      "id": "createasyncaction"
    }}>{`createAsyncAction`}</h2>
    <p>{`Returns a composite action-creator with nested action-creators for request, success and failure`}</p>
    <h3 {...{
      "id": "usage-1"
    }}>{`Usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createAsyncAction } from "re-reduced";

const doSomethingAsync = createAsyncAction("DO_SOMETHING_ASYNC");

console.log(doSomethingAsync.type); // => "DO_SOMETHING_ASYNC"
console.log(doSomethingAsync.request.type); // => "DO_SOMETHING_ASYNC_REQUEST"
console.log(doSomethingAsync.success.type); // => "DO_SOMETHING_ASYNC_SUCCESS"
console.log(doSomethingAsync.failure.type); // => "DO_SOMETHING_ASYNC_FAILURE"
`}</code></pre>
    <h2 {...{
      "id": "createactions"
    }}>{`createActions`}</h2>
    <p>{`A helper function to create bundled actions`}</p>
    <h3 {...{
      "id": "params-1"
    }}>{`Params`}</h3>
    <ul>
      <li parentName="ul">{`namespace (optional): string`}</li>
      <li parentName="ul">{`actionsContructor: api: CreateActionsAPI => ActionCreatorMap`}</li>
    </ul>
    <h3 {...{
      "id": "examples"
    }}>{`Examples`}</h3>
    <p>{`With namespace`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createActions } from "re-reduced";

const counterActions = createActions("COUNTER", create => ({
  inc: create.action(),
  dec: create.action(),
  adjust: create.action<number>()
}));

console.log(counterActions.inc.type); // => "COUNTER/INC"
console.log(counterActions.dec.type); // => "COUNTER/INC"
console.log(counterActions.adjust.type); // => "COUNTER/ADJUST"
`}</code></pre>
    <p>{`Alternatively, `}<inlineCode parentName="p">{`createActions`}</inlineCode>{` can be used with no namespace:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createActions } from "re-reduced";

const myActions = createActions(create => ({
  doSomething: create.action(),
  doSomethingAsync: create.asyncAction()
}));

console.log(myActions.doSomething.type); // => "DO_SOMETHING"
console.log(myActions.doSomethingAsync.type); // => "DO_SOMETHING_ASYNC"
console.log(myActions.doSomethingAsync.request.type); // => "DO_SOMETHING_ASYNC_REQUEST"
console.log(myActions.doSomethingAsync.success.type); // => "DO_SOMETHING_ASYNC_SUCCESS"
console.log(myActions.doSomethingAsync.failure.type); // => "DO_SOMETHING_ASYNC_FAILURE"
`}</code></pre>
    <h2 {...{
      "id": "createreducer"
    }}>{`createReducer`}</h2>
    <p>{`A utility function that returns a typesafe reducer`}</p>
    <h2 {...{
      "id": "connectwithactions"
    }}>{`connectWithActions`}</h2>
    <p>{`A utility wrapper on top of react-redux's connect that automatically adds actions to the component's props as a map of self-dispatchable action-creators`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      